import {css} from 'lit';
export const styles = css`:host {
  --member-background: var(--contrast-light);
  --border-color: var(--gray-100);
  --avatar-border: 2px solid var(--border-color);
  --link-text: var(--body-text);
  --link-text-hover: var(--body-text);
  --link-text-active: var(--body-text);

  position: relative;
  display: block;
}

ef-avatar {
  border: var(--avatar-border);
}

@media (min-width: 768px) {

ef-avatar {
    position: relative
}
  }

@media (min-width: 768px) {

a {
    margin-top: 20px
}
  }

@media (hover: hover) {
    a:hover {
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08), 0 2px 4px rgba(50, 50, 93, 0.14);
    }
  }

a.focus-visible {
    border-radius: 4px;
  }

a:focus-visible {
    border-radius: 4px;
  }

:host([layout='big']) a {
    display: block;
    position: relative;
  }

:host([layout='big']) ef-avatar {
    --border-color: var(--contrast-light);

    border: var(--avatar-border);
    border-color: var(--border-color);
  }

@media (min-width: 768px) {

:host([layout='big']) ef-avatar {
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, -50%);
      margin-bottom: 8px;
      z-index: 10
  }
    }

:host([layout='big']) .title {
    display: none;
  }

@media (min-width: 768px) {

:host([layout='big']) .title {
      display: block;
      margin: 0;
      padding: 28px 8px 8px;
      font-weight: normal;
      text-align: center;
      background: var(--member-background);
      border-radius: 4px;
      transition: box-shadow ease-in-out 0.2s
  }

      :host([layout='big']) .title > * {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
`;
export default styles;
